import get from "lodash/get";
import omit from "lodash/omit";
import { batch } from "react-redux";

import { getViewingAs } from "../../selectors/individualSelectors";
import { PATCH, POST } from "../../util/apiHelpers";

import { storageAvailable } from "../../util/storageHelpers";
import {
  MFA_REQUIRED,
  processIndividual,
  receiveEmailSettings,
  receiveViewingAs,
} from "../shared/individualActions";
import { clearJobcasts } from "../shared/jobcastActions";

// callback action types//
export const RECEIVE_INDIVIDUAL_POSITION_TEMPLATE =
  "RECEIVE_INDIVIDUAL_POSITION_TEMPLATE";

// callback actions//
export const receiveIndividualPositionTemplate = (positionTemplate) => ({
  type: RECEIVE_INDIVIDUAL_POSITION_TEMPLATE,
  payload: positionTemplate,
});

// api actions//
export const updateEmailSettings = (email_settings) => (dispatch) => PATCH("/api/v3/employer/email_settings", email_settings)
  .then((res) => {
    dispatch(receiveEmailSettings(res.data));
    return Promise.resolve();
  })
  .catch((error) => Promise.reject(error));

export const createEmployer = (formData) => (dispatch) => POST("/api/v3/individual/create_employer", formData)
  .then((res) => {
    if (res.data.sso_required) {
      return { sso_required: true, sso_redirect_url: res.data.sso_redirect_url };
    }
    if (res.data.mfa_required) {
      dispatch({
        type: MFA_REQUIRED,
        payload: {
          intermediate_session_token: res.data.intermediate_session_token,
          member_id: res.data.member_id,
          totp_registered: res.data.totp_registered,
        },
      });
      return { mfa_required: true, totp_registered: res.data.totp_registered };
    }
    return processIndividual(res.data, dispatch);
  })
  .catch((error) => Promise.reject(error.response.data));

export const setViewingAs = (viewingAs) => (dispatch, getState) => {
  const currViewingAsKey = get(getViewingAs(getState()), "key", "me");
  const viewingAsChanged = viewingAs.key !== currViewingAsKey;

  if (storageAvailable()) {
    viewingAs.key === "me"
      ? global.localStorage.removeItem("viewingAs")
      : global.localStorage.setItem(
        "viewingAs",
        JSON.stringify(omit(viewingAs, ["label"]))
      );
  }

  batch(() => {
    dispatch(receiveViewingAs(viewingAs));
    if (viewingAsChanged) {
      dispatch(clearJobcasts());
    }
  });
};
